import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_DOCUMENTTEMPLATE } from "../../../../utils/constants";
import { DocumentTemplateInterface } from "../../../../models/ProcurementModule/DocumentTemplate";
import documentTemplateService from "../../../../services/general/documentTemplateService";

const useDocumentTemplate = (page: number, pageSize: number) =>
  useQuery<DocumentTemplateInterface[], Error>({
    queryKey: [
      CACHE_KEY_DOCUMENTTEMPLATE,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => documentTemplateService.GetAll(page, pageSize),
    initialData: [],
  });

export default useDocumentTemplate;
